module.exports = __webpack_public_path__ + "img/Loader.8190df25.png";